import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleRight,
  faCircleLeft,
} from "@fortawesome/free-regular-svg-icons";
import { SanitizedHtml } from "wup-module1-base";

const WindowService = (data) => {
  let image = { backgroundImage: `url(${data.image})` };

  return (
    <>
      <div className="text-box1">
        <div className="title-1 ciz-title">{data.name}</div>
      </div>
      <div className="background-right">
        <div className="service-right">
          <div className="service-text">
            <SanitizedHtml html={data.text} />
          </div>
        </div>

        <div className="button-box-sevice display-button-desktop">
          <button
            className="button-confirm-service"
            onClick={() =>
              data.type === data.id
                ? data.changeMethod(null)
                : data.changeMethod(data.id)
            }
          >
            {data.type === data.id ? (
              <span className="accept-cancel-button-active">
                <span className="accept-cancel-button-text">
                  Kliknij, aby anulować
                </span>
                <FontAwesomeIcon
                  icon={faCircleLeft}
                  className="accept-cancel-button-icon"
                />
              </span>
            ) : (
              <span className="accept-cancel-button">
                <FontAwesomeIcon
                  icon={faCircleRight}
                  className="accept-cancel-button-icon"
                />
                <span className="accept-cancel-button-text">
                  Kliknij, aby wybrać
                </span>
              </span>
            )}
          </button>
        </div>
      </div>
      <div className="background_3" style={image} title={data.photo_name}></div>
      <div className="background-right-button-group display-button-mobile">
        <div className="button-box-sevice">
          <button
            className="button-confirm-service"
            onClick={() =>
              data.type === data.id
                ? data.changeMethod(null)
                : data.changeMethod(data.id)
            }
          >
            {data.type === data.id ? (
              <span className="accept-cancel-button-active">
                <span className="accept-cancel-button-text">
                  Kliknij, aby anulować
                </span>
                <FontAwesomeIcon
                  icon={faCircleLeft}
                  className="accept-cancel-button-icon"
                />
              </span>
            ) : (
              <span className="accept-cancel-button">
                <FontAwesomeIcon
                  icon={faCircleRight}
                  className="accept-cancel-button-icon"
                />
                <span className="accept-cancel-button-text">
                  Kliknij, aby wybrać
                </span>
              </span>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default WindowService;
